"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Middleware_helpers_1 = require("../Middleware.helpers");
/**
 * Session Middleware will store new auth token and update it when a new token is available
 * @param sessionConfig
 */
var sessionManagerMiddleware = function (sessionConfig) { return function () { return function (next) { return function (action) {
    var isResponseAction = Middleware_helpers_1.contains(sessionConfig.actions, action.type);
    var currentAuthToken = isResponseAction && localStorage.getItem(sessionConfig.responseKey);
    if (isResponseAction) {
        var authHeaderToken = action.responseHeaders &&
            action.responseHeaders[sessionConfig.responseKey];
        var authBodyToken = action.responseBody && action.responseBody[sessionConfig.responseKey];
        var token = authHeaderToken || authBodyToken;
        var isNewAuthToken = currentAuthToken !== token;
        // Update the token when there is a new one available
        if (token && isNewAuthToken) {
            try {
                localStorage.setItem(sessionConfig.storageKey, token);
            }
            catch (e) {
                throw new Error("[SESSION MANAGER MIDDLEWARE] " + e.message);
            }
        }
    }
    return next(action);
}; }; }; };
exports.default = sessionManagerMiddleware;
//# sourceMappingURL=SessionManagerMiddleware.js.map